import React from "react";
import SumsubWebSdk from "@sumsub/websdk-react";

interface KycHelperInterface {
  accessToken: string;
}

export const KycHelper: React.FC<KycHelperInterface> = ({ accessToken }) => {
  const config = {
    lang: "en",
    theme: "light",
    customCSS: ".sumsub-header { background-color: #f4f4f4; }",
    mobileMode: false,
    iframeContainerId: "sumsub-iframe-container",
  };

  const accessTokenExpirationHandler = (): Promise<string> => {
    return Promise.resolve("newaccessToken");
  };

  const messageHandler = () => {};

  const errorHandler = () => {};

  return (
    <SumsubWebSdk
      accessToken={accessToken}
      expirationHandler={accessTokenExpirationHandler}
      config={config}
      options={{
        enableScrollIntoView: true,
      }}
      onMessage={messageHandler}
      onError={errorHandler}
    />
  );
};

export default KycHelper;
